<script lang="ts">
	import { onMount } from 'svelte';

	export let text: string;

	let container: HTMLDivElement;

	function setContainerStyles(container: HTMLDivElement) {
		const style = getComputedStyle(container);
		const lineHeight = parseFloat(style.lineHeight);

		// Set height to two lines
		const twoLineHeight = lineHeight * 2;
		container.style.height = `${twoLineHeight}px`;

		let minWidth = 64;
		let maxWidth = window.innerWidth;
		let midWidth = maxWidth;

		while (minWidth <= maxWidth) {
			midWidth = Math.floor((minWidth + maxWidth) * 0.5);
			container.style.width = `${midWidth}px`;

			if (container.scrollHeight > twoLineHeight) {
				minWidth = midWidth + 1;
			} else {
				maxWidth = midWidth - 1;
			}
		}
		container.style.width = `${minWidth}px`;
	}

	onMount(() => {
		setContainerStyles(container);

		const listener = () => setContainerStyles(container);

		window.addEventListener('resize', listener);

		return () => window.removeEventListener('resize', listener);
	});
</script>

<div bind:this={container} class="line-clamp-2 overflow-hidden">
	{text}
</div>
